import { Button, Group, Modal, Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

interface SignOutConfirmationProps {
  opened: boolean;
  onClose: () => void;
  onSignOut: () => void;
}

export default function SignOutConfirmation({
  opened,
  onClose,
  onSignOut,
}: SignOutConfirmationProps) {
  const handleConfirmSignOut = () => {
    onSignOut();
    onClose();
  };

  return (
    <Modal
      centered
      zIndex={1000}
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      title={
        <TextWrapper size="xl" ta="center" c="burgundy.9" variant="bold">
          Sign Out
        </TextWrapper>
      }
    >
      <Stack>
        <TextWrapper ta="center">Are you sure you want to sign out?</TextWrapper>
        <Group pt="sm" justify="space-between" mx={{ base: "xs", xs: 0 }}>
          <Button
            bg="red.1"
            color="red.8"
            variant="outline"
            onClick={onClose}
            data-testid="user-menu-sign-out-cancel"
          >
            Cancel
          </Button>
          <Button
            bg="indigo.1"
            variant="outline"
            color="burgundy.9"
            onClick={handleConfirmSignOut}
            data-testid="user-menu-sign-out"
          >
            Sign Out
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
